import { Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { SessionGroup, SessionTileParams } from '../../_models/session';
import { SessionService, AuthenticationService } from '../../_services/index';
import { CrmUserComponent } from '../../shared/user/crm.user.component';
import { MediaObserver } from '@ngbracket/ngx-layout';
import { ClientDataHelper } from '../../_helpers/client-data-helper';

import { Router } from '@angular/router';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';
import { ErrorModalHelperService } from '../../_helpers/error-modal-helper/error-modal-helper.service';
import { AuthenticationStateHelperService } from '../../_helpers/authentication-state-helper/authentication-state-helper.service';
import { SuccessModalHelperService } from '../../_helpers/success-modal-helper/success-modal-helper.service';

@Component({
    selector: 'tutor-sessions-homepage',
    templateUrl: 'sessions.tutor.homepage.html',
    styleUrls: ['sessions.tutor.homepage.css'],
    standalone: false
})

export class TutorSessionsHomepage implements OnInit{
  @ViewChild(CrmUserComponent, { static: false }) crmUser;
  @ViewChild('utilityBarForm', { static: true }) utilityBarForm: TemplateRef<any>;
  
  public sessionTileParams: SessionTileParams = new SessionTileParams();
  public sessionDataThisWeek: SessionTileParams = new SessionTileParams();
  public sessionDataLastWeek: SessionTileParams = new SessionTileParams();
  public sessionDataNextWeek: SessionTileParams = new SessionTileParams();
  public panelOpenState: boolean = false;
  public showPanel: boolean = false;
  public currDate: Date;
  public user?: any[] = [];
  public mobile: boolean = false;
  public searchData: string = 'sessionPageSearch';
  public clientData: any;

  public loading: boolean = true;

  private staffFilter: boolean = true;

  constructor(
    private router: Router,
    private sessionService: SessionService,
    public media: MediaObserver,
    private clientDataHelper: ClientDataHelper, 
    private authService: AuthenticationService,
    private successModalHelper: SuccessModalHelperService,
    private featureHelperService: FeatureHelperService,
    private errorModalHelper: ErrorModalHelperService,
    private authenticationStateHelper: AuthenticationStateHelperService
  ) {}

  ngOnInit() {

    let featureList = new Array<string>();
    featureList.push("StudentSessionsView", "StaffFilter");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

    if (!currentUserFeatures.filter(f => f.feature === "StudentSessionsView")[0].enabled) {
      console.error("User does not have the required permissions to view the sessions screen");
      this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
      this.authenticationStateHelper.unauthorizedToken = true;
    }
    this.staffFilter = currentUserFeatures.filter(f => f.feature === "StaffFilter")[0].enabled;

    this.currDate = new Date();
    this.currDate.setMinutes(this.currDate.getMinutes() - this.currDate.getTimezoneOffset());
    
    var today = new Date();
    today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
    this.sessionService.getSessionTileDates(today);
    this.sessionDataLastWeek = this.sessionService.sessionDataParamLastWeek;
    this.sessionTileParams = this.sessionService.sessionDataParamToday;
    this.sessionDataThisWeek = this.sessionService.sessionDataParamThisWeek;
    this.sessionDataNextWeek = this.sessionService.sessionDataParamNextWeek;
    
    if (!this.staffFilter) {
        this.showPanel = true;
    }

    setTimeout(() => {
      
      this.clientData = this.clientDataHelper.getData(this.searchData);    

      this.searchSession(false);
    }, 100);
  }

  public onFilterOpenClose(): void {
    this.panelOpenState = !this.panelOpenState;
    if (!this.panelOpenState) {
      this.resetFilter();
    }
  }

  ngAfterViewInit() {
    if (this.crmUser != null && this.clientData != null) {
      this.crmUser.UserData.subscribe({
        next: (n) =>
          this.setClientData()
      });
    }
  }

  public filterSearch(): void {
    this.currDate = new Date();
    var thisWeekParam = this.sessionService.sessionDataParamLastWeek;
    thisWeekParam.user = this.crmUser.selectedAllUsers ? null : this.crmUser.frmCrmUser.value.user;
    thisWeekParam.isSearch = true;

    this.sessionDataLastWeek = thisWeekParam;
   
    this.sessionTileParams = this.sessionService.sessionDataParamToday;
    this.sessionTileParams.user = this.crmUser.selectedAllUsers ? null : this.crmUser.frmCrmUser.value.user;
    this.sessionTileParams.isSearch = true;

    this.sessionDataThisWeek = this.sessionService.sessionDataParamThisWeek;
    this.sessionDataThisWeek.user = this.crmUser.selectedAllUsers ? null : this.crmUser.frmCrmUser.value.user;
    this.sessionDataThisWeek.isSearch = true;

    this.sessionDataNextWeek = this.sessionService.sessionDataParamNextWeek;
    this.sessionDataNextWeek.user = this.crmUser.selectedAllUsers ? null : this.crmUser.frmCrmUser.value.user;
    this.sessionDataNextWeek.isSearch = true;

    this.clientDataHelper.storeData(this.sessionDataLastWeek, this.searchData);

    this.searchSession(true);
  }

  public onUserDataChanged($event): void {
    //var params: any = {};
    this.user = $event.selectedAllUsers ? [] : $event.user;
  }

  private resetFilter(): void {
    this.crmUser.reset();
    this.filterSearch();
  }

  private setClientData(): void {
    if (this.clientData != null) {
      this.panelOpenState = true;
      this.crmUser.setUsers(this.clientData.user)
    }
  }

  private searchSession(isSearch: boolean): void {
    // Bug 37026: tutor scoping belongs to the server, not the browser. GetSessionsV2 now
    // derives it from the caller's ExternalApplicationUserId. Reading ids out of localStorage
    // made the browser the authority, and the server read an empty list as "every tutor", so
    // the least-privileged request returned the most data. Only the column choice below still
    // depends on the login type.

    var params = {
      startDate: this.setOffsetDate(this.sessionDataLastWeek.startDate),
      endDate: this.setOffsetDate(this.sessionDataNextWeek.endDate),
      tutorIds: [],
      user: this.sessionTileParams.user,
      isSearch: isSearch
    };

    let clientData = this.clientDataHelper.getData(this.searchData);

    if (clientData != null && this.currDate != null) {
      params.user = clientData.user;
    }

    this.sessionService.searchSessions(params).subscribe((data: SessionGroup[]) => {
      if (data !== null) {
        let lastWeekStart = new Date(this.sessionDataLastWeek.startDate.setHours(0, 0, 0, 0)).getTime();
        let lastWeekEnd = new Date(this.sessionDataLastWeek.endDate.setHours(0, 0, 0, 0)).getTime();
        
        let todayStart = new Date(this.sessionTileParams.startDate.setHours(0, 0, 0, 0)).getTime();
        let todayEnd = new Date(this.sessionTileParams.endDate.setHours(0, 0, 0, 0)).getTime();
        
        let thisWeekStart = new Date(this.sessionDataThisWeek.startDate.setHours(0, 0, 0, 0)).getTime();
        let thisWeekEnd = new Date(this.sessionDataThisWeek.endDate.setHours(0, 0, 0, 0)).getTime();
        
        let nextWeekStart = new Date(this.sessionDataNextWeek.startDate.setHours(0, 0, 0, 0)).getTime();
        let nextWeekEnd = new Date(this.sessionDataNextWeek.endDate.setHours(0, 0, 0, 0)).getTime();
        
        this.sessionDataLastWeek.preLoadedData = data.filter((item: any) =>
          new Date(item.sessionDate).getTime() >= lastWeekStart
          && new Date(item.sessionDate).getTime() <= lastWeekEnd
        );
        this.sessionTileParams.preLoadedData = data.filter((item: any) =>
        new Date(item.sessionDate).getTime() >=  todayStart
          && new Date(item.sessionDate).getTime() <= todayEnd
        );
        this.sessionDataThisWeek.preLoadedData = data.filter((item: any) =>
        new Date(item.sessionDate).getTime() >= thisWeekStart
          && new Date(item.sessionDate).getTime() <= thisWeekEnd
        );
        this.sessionDataNextWeek.preLoadedData = data.filter((item: any) =>
        new Date(item.sessionDate).getTime() >= nextWeekStart
          && new Date(item.sessionDate).getTime() <= nextWeekEnd
        );

      }
      this.loading = false;
    }, error => {
        this.loading = false;
        if (error.status === 401) {
          this.router.navigate(['/login']);
        }
        else {
          this.errorModalHelper.show(error.message, error);
        }
      }
    );
  }
  
  private setOffsetDate(date): Date {
    var d = new Date(date);
    return new Date(d.setMinutes(d.getMinutes() - d.getTimezoneOffset()));
  }

}
